'use strict';

export default {
	POS_CONFIGURATION_LAYOUT: 'Pos Configuration Layout'
};